import groq from 'groq'

import { callToAction } from './callToAction.js'
import { imageAsset } from './imageAsset.js'
import { videoAsset } from './videoAsset.js'
import { postBodyFields } from './postBodyFields.js'

export function postBody({ includeLegalAddress = false } = {}) {
	const optionalFields = [
		includeLegalAddress ? `"legalAddress": *[_type == 'sharedContent'][0].legal` : null,
	].filter(Boolean)
	const optionalProjection = optionalFields.length ? `,\n  ${optionalFields.join(',\n  ')}` : ''

	return groq`
 _type,
  content[] {
    ...,	   
    _type == 'block' => {
      ...,
      style == null => {
        "style": 'normal'
      },
      markDefs[]{
        ...,
        _type == 'link' => {
          ...,
            "to": {
              ...,
              "_type": "external",
              "type": "external",
              "href": href
            }
        }
      }
    }, 
    _type == 'imageAsset' => {
     "image": {
      ...${imageAsset()}
     }
    },
    _type == 'videoAsset' => {
     "video": {
      ...${videoAsset()}
     }
    },
     _type == 'youtubeEmbed' => {
      url
    },
     _type == 'callToAction' => {
        ...${callToAction()}
    },
    ${postBodyFields}
  }${optionalProjection}
`
}
